import Layout from '../layout/Layout';
import { useEffect, useState } from 'react';
import { getQR } from '../api/whatsappApi';
import Swal from 'sweetalert2';

export default function WhatsApp() {
  const [qr, setQr] = useState(null);
  const [status, setStatus] = useState('Disconnected');

  useEffect(() => {
    loadQR();
  }, []);

  const loadQR = async () => {
    const res = await getQR();
    setQr(res.data.qr);
    setStatus('Waiting for scan');
  };

  return (
    <Layout>
      <h3>WhatsApp Connection</h3>

      <div className="card mt-3 p-4">
        <p>Status: <strong>{status}</strong></p>

        {qr && (
          <>
            <p>Scan QR with WhatsApp</p>
            <img src={qr} alt="QR" />
          </>
        )}
      </div>
    </Layout>
  );
}
